/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormEvent, useRef } from 'react';

import { Column, Row } from 'components/Blocks/Containers';
import { SearchIcon } from 'components/Blocks/Icons';

import ActionTitle from './Title';
import ApplyButton from './ApplyButton';
import ClearButton from './ClearButton';
import SearchInput from './SearchInput';
import { TableAction } from './Trigger';

import { useTable } from '../../Table';
import { TableColumn } from '../../types';

import { useFormControlV2 } from 'hooks';

import { getColumnKey } from './utils';

interface SearchButtonProps {
  column: TableColumn<any>;
  index: number;
}

export function SearchButton({ column, index }: SearchButtonProps): JSX.Element {
  const { searches, dispatch } = useTable();

  const searchKey = getColumnKey(column, index);
  const search = searches[searchKey] ?? '';

  const inputRef = useRef<HTMLInputElement>(null);

  const [localState, localHandlers] = useFormControlV2({
    search: '',
    open: false,
  });

  const active = !!search.trim();

  const updateSearch = (term: string): void => {
    dispatch({
      searches: ({ searches }) => ({
        ...searches,
        [searchKey]: term,
      }),
    });
  };

  const clear = (): void => {
    localHandlers.dispatch({ search: '' });
    updateSearch('');
  };

  const executeSearch = (event: FormEvent): void => {
    event.preventDefault();

    updateSearch(localState.search);
  };

  return (
    <TableAction icon={<SearchIcon size={10} />} isActive={active}>
      <Column as="form" onSubmit={executeSearch}>
        <Row justifyContent="space-between">
          <ActionTitle>Search</ActionTitle>

          {active && <ClearButton onClick={clear} />}
        </Row>

        <SearchInput
          ref={inputRef}
          value={localState.search}
          onChange={({ target }) => localHandlers.dispatch({ search: target.value })}
        />

        <ApplyButton type="submit" />
      </Column>
    </TableAction>
  );
}
